/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Ideon provider entity type captured when the provider was selected
 */
export enum ProviderType {
  individual = 'individual',
  organization = 'organization',
}
